module.exports = __webpack_public_path__ + "static/img/banner-content-mom.f81a565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-content-mom.png
// module id = 182
// module chunks = 1